// import * as types from "./types";
import { debug, cheat } from "../../../util/Params";

console.log("debug", debug);

/*
外部設定で読み込みたいもの
history max
GPS距離閾値
最大表示件数？

 */

// geolocationのチート。productionならやんない。production以外でcheatパラメータがあればやる。
let geoCheat = process.env.NODE_ENV !== "production";
if (geoCheat)
  geoCheat = geoCheat && !!cheat;
console.log("geoCheat", geoCheat);

export const config = {
  namespaced: true,

  state: {
    debug: debug,
    modalAutoCloseTime: 3000,
    putCursorInterval: 10000,
    geoCheat: geoCheat
  },
  getters: {
    debug: (state)=> state.debug
  },
  mutations: {
    // setMode(state, mode) {
    //   state.mode = mode;
    // }
  },
  actions: {
    // [types.SET_MODE]({ commit }, mode) {
    //   commit("setMode", mode);
    // }
  }
};
